import userSession from '@webapp-next/lib/user-session';
import getInstallationId from '@/lib/facades/get-installation-id';
import getTenantName from '@/lib/facades/get-portfolio-name';

/**
 * @return {{tenantId: (string), tenantName: (string), tenantUrl: (string)}}
 */
export function hrGetTenantInfo() {
  return {
    tenantId: getInstallationId(),
    tenantName: getTenantName(),
    tenantUrl: userSession().OriginalHostname,
  };
}
